// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1u1WR","right":"styles_right__2SNzM"};